<div class-roster>
  <div class-roster-body>
    <div class-roster-title>
      <h1>Class Roster</h1>
      <div (click)="openReport()" class="export-button">Export to Excel
        <img src="assets/icons/excel.svg" alt="" ml10>
        <img src="assets/icons/dropdown-button-down-white.svg" alt="" ml10>
        <ul export-dd [attr.show]="showReport">
          <li (click)="download('participants')">Classroom Attendance</li>
          <li (click)="download('wellbeing')">Well-being Check</li>
        </ul>
      </div>
    </div>
    <div class="tab-body">
      @if (!isConfirmed) {
        <div>
          @if (isFacilitatorOver==='disable') {
            <div class="notification">
              <div>
                <p>The attendance record as shown is an accurate record of each participant’s attendance.</p>
                <p class="text-gray">
                  <img src="assets/icons/confirmation-not_due.svg" alt=""> Facilitator Must Confirm Attendance</p>
                </div>
                <button type="button" class="btn-primary" disabled (click)="confirm()">Confirm Attendance</button>
              </div>
            }
            @if (isFacilitatorOver==='allow') {
              <div class="notification warning">
                <div>
                  <p>The attendance record as shown is an accurate record of each participant’s attendance.</p>
                  <p class="text-gray">
                    <img src="assets/icons/confirmation-pending.svg" alt="">Facilitator Must Confirm Attendance&bull; &nbsp;
                    <span class="jp-bold" red>Action Required</span>
                  </p>
                </div>
                <button type="button" class="btn-primary" (click)="confirm()">Confirm Attendance</button>
              </div>
            }
            @if (isFacilitatorOver==='over') {
              <div class="notification danger">
                <div>
                  <p>The attendance record as shown is an accurate record of each participant’s attendance.</p>
                  <p class="text-danger">
                    <img src="assets/icons/confirmation-overdue.svg" alt="">Facilitator Must Confirm Attendance&bull; &nbsp;
                    <span class="jp-bold" red>Action Required</span>
                  </p>
                </div>
                <button type="button" class="btn-primary" (click)="confirm()">Confirm Attendance</button>
              </div>
            }
            @if (doConfirm) {
              <div>
                <section class="popover">
                  <div>
                    <span>Once you confirm attendance, only Admin can make changes. Do you wish to confirm and close participant attendance?</span>
                    <article>
                      <button (click)="cancelConfirm()">Cancel</button>
                      <button (click)="saveConfirm()">Confirm</button>
                    </article>
                  </div>
                </section>
              </div>
            }
          </div>
        }
        @if (isConfirmed) {
          <div class="notification success">
            @if (confirmationData) {
              <div>
                <p><b>The attendance record as shown is an accurate record of each participant’s attendance.</b></p>
                <p class="text-green">
                  <img src="assets/icons/confirmation-confirmed.svg" alt=""><p class="text-gray">{{confirmationData?.firstName}} {{confirmationData?.lastName}} • {{confirmationData?.createdDate | dateFormat : 'mmddyyyy'}} • {{confirmationData?.createdDate |dateFormat : 'coursetime'}}
                </p>
              </div>
              <button type="button" class="btn-success">Attendance Confirmed <i class="material-icons">check_circle</i></button>
            } @else {
              <p class="background-white m-t-xs">
                <span class="m-l-lg">
                  <error-message [errorMessage]="confirmationDataErrorMessage"></error-message>
                </span>
              </p>
            }
          </div>
        }
        @if (facilitators) {
          <div class="panel">
            <div class="panel-header">
              <div class="panel-title">
                <p class="panel-title">Facilitator Attendance ({{facilitators.length}})</p>
              </div>
              <div class="display-flex">
                <div class="expand-button" (click)="expandAll('facilitator')">Expand rows</div>
                <span class="m-l-sm m-r-sm pipe">|</span>
                <div class="expand-button m-r-sm" (click)="collapseAll('facilitator')">Collapse rows</div>
              </div>
            </div>
            <div class="panel-body">
              @if (facilitators?.length) {
                <table class="table facilitator-table">
                  <thead>
                    <th (click)="sort('fullName','facilitator')">
                      <span>Name</span>
                      <img [ngClass]="{'active':isNameAsc}" src="assets/icons/sort-by-down.svg" alt="">
                    </th>
                    <th (click)="sort('email','facilitator')">
                      <span>Email</span>
                      <img [ngClass]="{'active':isEmailAsc}" src="assets/icons/sort-by-down.svg" alt="">
                    </th>
                    @if (facilitatorAttendance) {
                      <th>
                        <span>Facilitation</span>
                      </th>
                    }
                    @if (facilitatorAttendance) {
                      <th>
                        <span>Participation</span>
                      </th>
                    }
                    <th>
                      <span>Time Missed</span>
                    </th>
                  </thead>
                  <tbody>
                    @for (data of facilitators | orderBy: {property: column, direction: direction}; track data; let i = $index) {
                      <tr [attr.edit]="data?.isEdit">
                        <td>
                          <div>
                            <span>{{data?.fullName}} {{ data?.edit }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{data?.email}}</span>
                          </div>
                        </td>
                        @if (facilitatorAttendance) {
                          <td>
                            <div class="time-item">
                              <mat-form-field>
                                <select matNativeControl [ngModel]="data?.facilitationResponse?.facilitationResponse" (change)="handleFacilitationResponse($event, data?.facilitationResponse, data.participantId, 'facilitation')">
                                  <option value="Some Modules">Some Modules</option>
                                  <option value="Entire Modules">Entire Modules</option>
                                  <option value="NA">N/A</option>
                                </select>
                              </mat-form-field>
                            </div>
                            @if (data?.facilitationResponse?.facilitationResponse==='Some Modules' || data?.facilitationResponse?.facilitationResponse==='Entire Modules') {
                              <div timeexpanded>
                                <div class="total">
                                  <span>Total Facilitated:</span><span>{{ data?.facilitationTime | timeTotal }}</span>
                                </div>
                                @for (f of data?.facilitationTime; track f) {
                                  <div class="time-row">
                                    <div>
                                      <span class="select-view" (click)="!enableCheckbox ? togglePicker(data.participantId,f,'checkIn','facilitation') : null">{{f?.checkInTime | dateFormat :'rosterTime'}}</span>
                                      <span class="text-gray">to</span>
                                      <span class="select-view" (click)="!enableCheckbox ? togglePicker(data.participantId,f,'checkOut','facilitation') : null">{{f?.checkOutTime | dateFormat :'rosterTime'}}</span>
                                      <span close (click)="!enableCheckbox ? delete(data.participantId,f,'facilitation', i) : null">
                                        <i class="material-icons">close</i>
                                      </span>
                                      @if (selectedPickerId === f?.id && selectedTarget === 'facilitation') {
                                        <time-picker [dateTime]="[selectedType === 'checkIn' ? f?.checkInTime : f?.checkOutTime,'']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                      }
                                    </div>
                                    <div>
                                      <div class="comment"></div>
                                      <span class="time-highlight">
                                        <i class="material-icons">access_time</i>{{f?.checkInTime | timeDiff : f?.checkOutTime }}&nbsp;Mins
                                      </span>
                                    </div>
                                  </div>
                                }
                                <div class="time-row">
                                  <div>
                                    <span class="select-view" blank (click)="!enableCheckbox ? togglePicker(data.participantId,null,'addCheckIn','facilitation') : null">{{addedFacilitation[i]?.checkInTime | dateFormat :'missedStartTime'}}</span>
                                    <span class="text-gray">to</span>
                                    <span class="select-view" blank (click)="!enableCheckbox ? togglePicker(data.participantId,null,'addCheckOut','facilitation') : null">{{addedFacilitation[i]?.checkOutTime | dateFormat :'missedEndTime'}}</span>
                                    <span></span>
                                    @if (selectedPickerId === 0 && selectedTarget === 'facilitation' && selectedIndex === i) {
                                      <time-picker [dateTime]="['','']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </td>
                        }
                        @if (facilitatorAttendance) {
                          <td>
                            <div class="time-item">
                              <mat-form-field>
                                <select matNativeControl [ngModel]="data?.facilitationResponse?.participationResponse" (change)="handleFacilitationResponse($event, data?.facilitationResponse, data.participantId)">
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                  <option value="NA">N/A</option>
                                </select>
                              </mat-form-field>
                            </div>
                            @if (data?.facilitationResponse?.participationResponse === 'Yes') {
                              <div timeexpanded>
                                <div class="total">
                                  <span>Total Paticipated:</span><span>{{ data?.participationTime | timeTotal }}</span>
                                </div>
                                @for (p of data?.participationTime; track p) {
                                  <div class="time-row">
                                    <div>
                                      <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,p,'checkIn','participation'):return">{{p?.checkInTime | dateFormat :'rosterTime'}}</span>
                                      <span class="text-gray">to</span>
                                      <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,p,'checkOut','participation'):return">{{p?.checkOutTime | dateFormat :'rosterTime'}}</span>
                                      <span close (click)="!enableCheckbox?delete(data.participantId, p, 'participation', i):return">
                                        <i class="material-icons">close</i>
                                      </span>
                                      @if (selectedPickerId === p?.id && selectedTarget === 'participation') {
                                        <time-picker [dateTime]="[selectedType === 'checkIn' ? p?.checkInTime : p?.checkOutTime,'']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                      }
                                    </div>
                                    <div>
                                      <div class="comment"></div>
                                      <span class="time-highlight">
                                        <i class="material-icons">access_time</i>{{p?.checkInTime | timeDiff : p?.checkOutTime }}&nbsp;Mins
                                      </span>
                                    </div>
                                  </div>
                                }
                                <div class="time-row">
                                  <div>
                                    <span class="select-view" blank (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckIn','participation'):return">{{addedParticipation[i]?.checkInTime | dateFormat :'missedStartTime'}}</span>
                                    <span class="text-gray">to</span>
                                    <span class="select-view" blank (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckOut','participation'):return">{{addedParticipation[i]?.checkOutTime | dateFormat :'missedEndTime'}}</span>
                                    <span></span>
                                    @if (selectedPickerId === 0 && selectedTarget === 'participation' && selectedIndex === i) {
                                      <time-picker [dateTime]="['','']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </td>
                        }
                        <td>
                          <div class="time-missed-box">
                            <label>
                              @if (totalTimeMissed(data?.totalMissed) !== 0) {
                                <label class="total-missed-label">
                                  Total Missed: <div class="pipe bold-text m-l-xs">
                                  {{totalTimeMissed(data?.totalMissed)}} Mins
                                </div>
                              </label>
                            }
                          </label>
                          <div class="time-item">
                            <span></span>
                            <div class="expand" (click)="expandCollapse('facilitator', data, i)">
                              @if (!data?.isEdit) {
                                <img src="assets/icons/expand-open-down.svg" alt="">
                              }
                              @if (data?.isEdit) {
                                <img src="assets/icons/expand-close-up.svg" alt="">
                              }
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{'m-t-lg' : totalTimeMissed(data?.totalMissed) !== 0}" timeexpanded>
                          @for (timeMissed of data?.totalMissed; track timeMissed) {
                            <div class="time-row">
                              <div>
                                <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,timeMissed,'checkIn','facilitator'):return">{{(timeMissed?.checkInTime) | dateFormat :'rosterTime'}}</span>
                                <span class="text-gray">to</span>
                                <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,timeMissed,'checkOut','facilitator'):return">{{timeMissed?.checkOutTime | dateFormat :'rosterTime'}}</span>
                                <span close (click)="!enableCheckbox?delete(data.participantId,timeMissed, 'facilitators', i):return">
                                  <i class="material-icons">close</i>
                                </span>
                                @if (selectedPickerId === timeMissed?.id && selectedTarget === 'facilitator') {
                                  <time-picker [dateTime]="[selectedType === 'checkIn' ? timeMissed?.checkInTime : timeMissed?.checkOutTime, '']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                }
                              </div>
                              <div>
                                <div class="comment">
                                  <!-- *ngIf="selectedIndex === i" -->
                                  <span (click)="toggleComment(timeMissed?.id,'facilitators')">
                                    <img src="assets/icons/comment.svg" alt=""></span>
                                    @if (selectedBox === timeMissed.id && commentBoxType === 'facilitators') {
                                      <div class="comment-box">
                                        <div comment-box-header>
                                          <span>
                                            <img src="assets/icons/comment.svg" alt="">{{timeMissed?.comments}}</span>
                                            <i class="material-icons" (click)="closeComment(i,'facilitators')">close</i>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                    <div class="total-time-count">
                                      <!-- <span class="time-highlight" [hidden]="true">
                                      <mat-icon> chat_bubble_outline</mat-icon>
                                    </span> -->
                                    <span class="time-highlight time">
                                      <i class="material-icons">access_time</i>
                                      {{timeMissed?.checkInTime | timeDiff : timeMissed?.checkOutTime }} Mins
                                    </span>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="time-row">
                              <div>
                                <span class="select-view" blank (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckIn','facilitator'):return">{{addedFacilitatorsInfo[i]?.checkInTime | dateFormat :'missedStartTime'}}</span>
                                <span class="text-gray">to</span>
                                <span class="select-view" blank (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckOut','facilitator'):return">{{addedFacilitatorsInfo[i]?.checkOutTime | dateFormat :'missedEndTime'}}</span>
                                <span></span>
                                @if (selectedPickerId === 0 && selectedTarget === 'facilitator'  && selectedIndex === i) {
                                  <time-picker [dateTime]="['','']" (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      @if (((addedFacilitatorsInfo[i]?.enableSaveCta && isShowSave) || updatedDetailCache?.length > 0)  && ((selectedIndex === i) || (participatiopnSelectedIndex === i) || (facilitationSelectedIndex === i))) {
                        <tr class="reason-row">
                          <td colspan="5">
                            <save-bar [showReason]="showReason" [newAddedDetails]="newAddedDetails" [isAdded]="isAdded" [isSuccess]="isSuccess" [isShowSave]="isShowSave || updatedDetailCache?.length > 0"
                              [type]="'facilitator'"
                              (toggle)="toggleRow(null,'facilitator')" [updatedDetailCache]="updatedDetailCache" [isDeleted]="isDeleted" [listText]="listText" (updateComment)="updateCommentFacilitator($event)"
                              [data]="addedFacilitatorsInfo[i]"
                            (toggleCancelWidget)="keepCancelWidgetEditing('facilitator')" (toggleSave)="getRosterFacilitators()"></save-bar>
                          </td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              } @else {
                <p class="background-white m-t-xs">
                  <span class="m-l-lg">
                    <error-message [errorMessage]="facilitatorsErrorMessage"></error-message>
                  </span>
                </p>
              }
            </div>
          </div>
        } @else {
          @if (!showLoading) {
            <div class="loading">
              <mat-spinner></mat-spinner>
            </div>
          }
        }
        @if (participants) {
          <div class="panel">
            <div class="panel-header">
              <div class="panel-title">
                <p>Participant Attendance ({{participants.length}})</p>
              </div>
              <div class="display-flex">
                <div class="expand-button" (click)="expandAll('participants')">Expand rows</div>
                <span class="m-l-sm m-r-sm pipe">|</span>
                <div class="expand-button m-r-sm" (click)="collapseAll('participants')">Collapse rows</div>
              </div>
            </div>
            <div class="panel-body">
              @if (participants?.length) {
                <table class="table participant-table">
                  <thead>
                    <th (click)="sort('fullName','participant')">
                      <span>Name</span>
                      <img src="assets/icons/sort-by-down.svg" [ngClass]="{'active':isParticipantNameAsc}" alt="">
                    </th>
                    <th (click)="sort('email','participant')">
                      <span>Email</span>
                      <img src="assets/icons/sort-by-down.svg" [ngClass]="{'active':isParticipantEmailAsc}" alt="">
                    </th>
                    <th>
                      <span>Check-in</span>
                    </th>
                    <th>
                      <span>Check-in By</span>
                    </th>
                    <th>
                      <span>Time Missed</span>
                    </th>
                  </thead>
                  <tbody>
                    @for (data of participants | orderBy: {property: participantColumn, direction: participantDirection}; track data; let i = $index) {
                      <tr [attr.edit]="data?.isEdit">
                        <td>
                          <div>
                            <span>{{data?.fullName}}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{data?.email}}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                                            <mat-checkbox [disabled]="data?.checkIn?.updatedBy == 'Code' || 
                                            data?.checkIn?.updatedBy == 'Beacon'
                                            ? true : false"
                            [attr.data-updatedBy]="data?.checkIn?.updatedBy" color="primary" value="{{data?.checkIn?.status}}" [checked]="data?.checkIn?.status" (change)="checkInStatus($event,data.participantId, data)"></mat-checkbox>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{data?.checkIn?.updatedBy}}</span>
                          </div>
                        </td>
                        <td>
                          <div class="time-missed-box">
                            <label>
                              @if (totalTimeMissed(data?.totalMissed) !== 0) {
                                <label class="total-missed-label">
                                  Total Missed: <div class="pipe bold-text m-l-xs">
                                  {{totalTimeMissed(data?.totalMissed)}} Mins
                                </div>
                              </label>
                            }
                          </label>
                          <div class="time-item">
                            <span></span>
                            <div class="m-l-sm" (click)="expandCollapse('participants', data, i)">
                              @if (!data?.isEdit) {
                                <img src="assets/icons/expand-open-down.svg" alt="">
                              }
                              @if (data?.isEdit) {
                                <img src="assets/icons/expand-close-up.svg" alt="">
                              }
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{'m-t-lg' : totalTimeMissed(data?.totalMissed) !== 0}" timeexpanded>
                          @for (timeMissed of data?.totalMissed; track timeMissed) {
                            <div class="time-row">
                              <div>
                                <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,timeMissed,'checkIn','participant'):return">{{timeMissed?.checkInTime | dateFormat :'rosterTime'}}</span>
                                <span class="text-gray">to</span>
                                <span class="select-view" (click)="!enableCheckbox?togglePicker(data.participantId,timeMissed,'checkOut','participant'):return">{{timeMissed?.checkOutTime | dateFormat :'rosterTime'}}</span>
                                <span close (click)="!enableCheckbox?delete(data.participantId,timeMissed, 'participants', i):return"><i class="material-icons">close</i></span>
                                @if (selectedPickerId === timeMissed.id && selectedTarget === 'participant') {
                                  <time-picker [dateTime]="[selectedType === 'checkIn'? timeMissed?.checkInTime : timeMissed?.checkOutTime, '']"
                                    (cancel)="togglePicker()"
                                  (update)="update($event)"></time-picker>
                                }
                              </div>
                              @if (timeMissed?.comments) {
                                <div>
                                  <div class="comment" >
                                    <span (click)="toggleComment(timeMissed?.id,'participants')">
                                      <img src="assets/icons/comment.svg" alt="">
                                    </span>
                                    @if (selectedParticipantBox === timeMissed.id && commentBoxType === 'participants') {
                                      <div class="comment-box">
                                        <div comment-box-header>
                                          <span><img src="assets/icons/comment.svg" alt="">{{timeMissed?.comments}}</span>
                                          <i class="material-icons" (click)="closeComment(i,'participants')">close</i>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  <div class="total-time-count">
                                    <span class="time-highlight participant-time">
                                      <i class="material-icons">access_time</i>
                                      {{timeMissed?.checkInTime | timeDiff : timeMissed?.checkOutTime }} Mins
                                    </span>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          <div class="time-row">
                            <div class="position-relative">
                              <span class="select-view" blank
                                (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckIn','participant'):return">
                                {{addedParticipantsInfo[i]?.checkInTime | dateFormat :'missedStartTime'}}
                              </span>
                              <span class="text-gray">to</span>
                              <span class="select-view participant-endtime" blank
                                (click)="!enableCheckbox?togglePicker(data.participantId,null,'addCheckOut','participant'):return">
                                {{addedParticipantsInfo[i]?.checkOutTime | dateFormat :'missedEndTime'}}
                              </span>
                              <div class="position-absolute participant-time-picker">
                                @if (selectedPickerId === 0 && selectedTarget === 'participant' && participantSelectedIndex === i) {
                                  <time-picker [dateTime]="['','']"
                                  (cancel)="togglePicker()" (update)="update($event)"></time-picker>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    @if (((addedParticipantsInfo[i]?.checkInTime !== 'Add Time' && addedParticipantsInfo[i]?.checkOutTime !== 'Add Time') || (addedParticipantsInfo[i]?.enableSaveCta && isShowSave) ||  (updatedDetailCache?.length > 0)) && participantSelectedIndex === i) {
                      <tr class="reason-row">
                        <td colspan="6">
                          <save-bar [showReason]="true" [newAddedDetails]="newAddedDetails" [isAdded]="isAdded" [isSuccess]="isSuccess" [isShowSave]="(addedParticipantsInfo[i]?.checkInTime !== 'Add Time' && addedParticipantsInfo[i]?.checkOutTime !== 'Add Time') || addedParticipantsInfo[i]?.enableSaveCta || updatedDetailCache?.length > 0"
                            (toggle)="toggleRow(null,'participants')" [updatedDetailCache]="updatedDetailCache" [isDeleted]="isDeleted"
                            [type]="'participants'"  (updateComment)="updateCommentFacilitator($event)"
                            [listText]="listText" (toggleCancelWidget)="keepCancelWidgetEditing('participants')"  [index]="i"
                            [data]="addedParticipantsInfo[i]"
                          (toggleSave)="getRosterParticipants()"></save-bar>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            } @else {
              <p class="background-white m-t-xs">
                <span class="m-l-lg">
                  <error-message [errorMessage]="participantsErrorMessage"></error-message>
                </span>
              </p>
            }
          </div>
        </div>
      } @else {
        @if (!showLoading) {
          <div class="loading">
            <mat-spinner></mat-spinner>
          </div>
        }
      }
    </div>
  </div>
</div>
<div cancel-widget [attr.showCancelWidget]="cancelModel">
  <div>
    <span>Are you sure you want to exit and lose changes?</span>
    <article>
      <button (click)="cancelWidgetConfirm()">Cancel</button>
      <button (click)="keepCancelWidgetEditing('')">Keep Editing</button>
    </article>
  </div>
</div>
